import axios from "axios";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

const checkAuth = () => {
  const TOKEN = Cookies.get("token");
  const PUBLIC_ROUTES = [
    "login",
    "forgot-password",
    "register",
    "documentation",
    "arrive",
  ];

  const isPublicPage = PUBLIC_ROUTES.some((r) =>
    window.location.href.includes(r)
  );

  if (!TOKEN) {
    if (!isPublicPage) {
      window.location.href = "/login";
    }
    return null;
  }

  try {
    const decodedToken = jwtDecode(TOKEN);
    const currentTime = Date.now() / 1000;

    if (decodedToken.exp < currentTime) {
      Cookies.remove("token");
      if (!isPublicPage) {
        window.location.href = "/login";
      }
      return null;
    }

    // Validate token format
    if (!TOKEN.split(".").length === 3) {
      Cookies.remove("token");
      if (!isPublicPage) {
        window.location.href = "/login";
      }
      return null;
    }

    axios.defaults.headers.common["Authorization"] = `Bearer ${TOKEN}`;

    // Add request/response interceptors
    axios.interceptors.request.use(
      (config) => {
        document.body.classList.add("loading-indicator");
        return config;
      },
      (error) => Promise.reject(error)
    );

    axios.interceptors.response.use(
      (response) => {
        document.body.classList.remove("loading-indicator");
        return response;
      },
      (error) => {
        document.body.classList.remove("loading-indicator");
        if (error.response?.status === 401) {
          Cookies.remove("token");
          window.location.href = "/login";
        }
        return Promise.reject(error);
      }
    );

    return TOKEN;
  } catch (error) {
    Cookies.remove("token");
    if (!isPublicPage) {
      window.location.href = "/login";
    }
    return null;
  }
};

export default checkAuth;
